// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e7b7db44","890":"eb3dda6f"}[chunkId] + ".chunk.js";
};